import {consoleEntrySvg as Icon__small__consoleEntrySvg} from '../Icon__small/Icon__small--consoleEntry.js';

export var consoleEntry = {
  name: 'consoleEntry',
  category: 'icon',
  colorable: true,
  svg: Icon__small__consoleEntrySvg,
};
